<template>
	<section class="d-flex h-100 w-100">


				<div v-if="isLoading" class="d-flex justify-content-center align-items-center w-100">
					<div class="d-flex spinner-border text-dark" role="status" />
				</div>

				<div v-else class="w-100">

						<h3 class="mt-3">
							{{formLabel}}
						</h3>

						<!-- BOX CONTAINER -->
						<div class="alert alert-light">
              <div v-if="isAnswered" class="text-center">

                <h3>Merci d'avoir pris le temps de répondre !</h3>
                <p class="question-hint">
                  Vous pouvez fermer cette fenêtre.
                </p>

              </div>
              <div v-else>

                <h4 class="question-label">Dans quel type de logement la box Emotivi sera installée ?</h4>
                <p class="question-hint m-0">Choississez une valeur dans le menu déroulant ci-dessous.</p>

                <select v-model="buildingType" class="form-select">
                  <option v-for="buildingType, index in buildingTypes" :index="index">{{ buildingType }}</option>
                </select>

                <h4 class="question-label mt-4">Pouvez-vous précisez le fournisseur d'accès à internet du logement ?</h4>
                <p class="question-hint m-0">Choississez une valeur dans le menu déroulant ci-dessous.</p>

                <select v-model="internetProvider" class="form-select">
                  <option v-for="internetProvider, index in internetProviders" :index="index">{{ internetProvider }}</option>
                </select>


                <h4 class="question-label mt-4">Pouvez-vous précisez le type de connexion du fournisseur d'accès ?</h4>
                <p class="question-hint m-0">Choississez une valeur dans le menu déroulant ci-dessous.</p>

                <select v-model="connectionType" class="form-select">
                  <option v-for="connectionType, index in connectionTypes" :index="index">{{ connectionType }}</option>
                </select>


                <h4 class="question-label mt-4">Pouvez-vous précisez par quel moyen le senior regarder les chaines de télévision ?</h4>
                <p class="question-hint m-0">Choississez une valeur dans le menu déroulant ci-dessous.</p>

                <select v-model="tvChannelsProvider" class="form-select">
                  <option v-for="tvChannelsProvider, index in tvChannelsProviders" :index="index">{{ tvChannelsProvider }}</option>
                </select>

                <h4 class="question-label mt-4">Pouvez-vous précisez la marque du téléviseur ?</h4>
                <p class="question-hint m-0">Choississez une valeur dans le menu déroulant ci-dessous.</p>

                <select v-model="tvBrand" class="form-select">
                  <option v-for="tvBrand, index in tvBrands" :index="index">{{ tvBrand }}</option>
                </select>

                <h4 class="question-label mt-4">Habitez-vous à moins de 30 min. du senior ?</h4>
                <p class="question-hint m-0">Cochez une réponse ci-dessous.</p>

                <div class="form-check form-check-inline">
                  <input v-model="seniorDistance" class="form-check-input" name="senior_distance" type="radio" id="senior_distance_yes" value="1">
                  <label class="form-check-label" for="senior_distance_yes">Oui</label>
                </div>
                <div class="form-check form-check-inline">
                  <input v-model="seniorDistance" class="form-check-input" name="senior_distance" type="radio" id="senior_distance_no" value="0">
                  <label class="form-check-label" for="senior_distance_no">Non</label>
                </div>

                <h4 class="question-label mt-4">Un proche peut-il se rendre sur place en cas de besoin ?</h4>
                <p class="question-hint m-0">Cochez une réponse ci-dessous.</p>

                <div class="form-check form-check-inline">
                  <input v-model="relativeDistance" class="form-check-input" name="relative_distance" type="radio" id="relative_distance_yes" value="1">
                  <label class="form-check-label" for="relative_distance_yes">Oui</label>
                </div>
                <div class="form-check form-check-inline">
                  <input v-model="relativeDistance" class="form-check-input" name="relative_distance" type="radio" id="relative_distance_no" value="0">
                  <label class="form-check-label" for="relative_distance_no">Non</label>
                </div>

              </div>
            </div>
            <div v-show="!isAnswered" class="text-end mb-3">
              <button class="btn btn-large btn-primary" @click="submitForm">Valider</button>
            </div>
        </div>

  </section>
</template>

<script>

export default {
  name: "feedback",
  components: {
  },
  data() {
    return {
			isLoading: false,
      isAnswered: false,
      formLabel: "",

      buildingType: "",
      buildingTypes: [
        "Maison",
        "Appartement",
        "Résidence senior/EHPAD"
      ],

      internetProvider: "",
      internetProviders: [
        "Bouygues",
        "Free",
        "SFR",
        "Orange",
        "Numéricable",
        "Starlink",
        "Aucun",
        "Autre",
        "Je ne sais pas"
      ],

      connectionType: "",
      connectionTypes: [
        "ADSL",
        "Fibre",
        "4/5G",
        "WIFI de la résidence/EHPAD",
        "Autre",
        "Je ne sais pas",
      ],

      tvChannelsProvider: "",
      tvChannelsProviders: [
        "Chaînes TNT",
        "Player TV Free",
        "Player TV Orange",
        "Décodeur Bbox",
        "Décodeur Connect TV SFR",
        "Décodeur CANAL+",
        "Autre",
        "Je ne sais pas",
      ],

      tvBrand: "",
      tvBrands: [
        "Acoustic Solutions", "Akai", "Amazon", "Amplivision",
        "Aoc","Asus", "AYA", "Bang & Olufsen", "Blaupunkt", "Brandt",
        "Bush", "Cecotec", "Changhong", "Chiq", "Clayton", "Compaq",
        "Continental Edison", "Daewoo", "Denver", "Devialet", "Dreame",
        "Edenwood", "Element", "Engel", "Essentielb", "Faura", "Finlux",
        "Fujitsu", "Funai", "Goodmans", "Grandin", "Grundig", "Grunkel",
        "Haier", "Hisense", "Hitachi", "HKC", "Huawei", "Hyundai", "Infiniton",
        "Insignia", "JVC", "Kaïsui", "Kendo", "Kenwood", "Konka", "LeEco",
        "LG", "Loewe", "Luxor", "Magnavox", "Maxwell", "Medion", "Metz", 
        "Metz Blue", "Micromax", "Mitsubishi", "Motorola", "Nevir", "Nilait",
        "Nokia", "Océanic", "OK.", "Onida", "Panasonic", "Pathé-Cinéma", 
        "Pathé-Marconi", "Peaq", "Philco", "Philips", "Pioneer", "Polaroid",
        "Princeton", "Qilive", "RCA", "Realme", "Roku", "Saba", "Salora", 
        "Samsung", "Sansui", "Sanyo", "Sceptre", "Schneider", "Selecline",
        "Setif", "Sharp", "Skyworth", "SmartTech", "Sonolor", "Sony", "Strong",
        "Sylvox", "TCL", "TD Systems", "Technika", "Techwood", "Téléavia",
        "Telefunken", "Thomson", "Toshiba", "Tucson", "Vestel", "Videocon",
        "Vizio", "Westinghouse", "Zenith", "je ne sais pas", "Autre"
      ]
    };
  },
  mounted() {
    this.loadData();
  },

  methods: {

    async loadData() {
  
			this.isLoading = true;
			let response = await this.$axios.get(`${this.$config.server_url}/web/2.0/extradata/${this.$route.params.token}`);
			this.isLoading = false;

			if(response.data.err) {

			} else {
        let data = response.data.data.ed_data;
			  this.formLabel = response.data.data.ed_label;
        this.buildingType = data.buildingType.value;
        this.internetProvider = data.internetProvider.value;
        this.connectionType = data.connectionType.value;
        this.tvChannelsProvider = data.tvChannelsProvider.value;
        this.tvBrand = data.tvBrand.value;
        this.seniorDistance = data.seniorDistance.value;
        this.relativeDistance = data.relativeDistance.value;
			}
    },

    updateRating(newRating) {
      // Handle the new rating as needed.
      this.userRating = newRating;
    },

    async submitForm() {

      let ed_data = {
        buildingType: {
          label: "Type de logement",
          value: this.buildingType,
        },
        internetProvider: {
          label: "FAI du logement",
          value: this.internetProvider,
        },
        connectionType: {
          label: "Type de connexion",
          value: this.connectionType
        },
        tvChannelsProvider: {
          label: "Chaines de TV",
          value: this.tvChannelsProvider
        },
        tvBrand: {
          label: "Marque du téléviseur",
          value: this.tvBrand
        },
        seniorDistance: {
          label: "Senior à moins de 30 min.",
          value: this.seniorDistance
        },
        relativeDistance: {
          label: "Proche à proximité du senior",
          value: this.relativeDistance
        }
      };

			let response = await this.$axios.put(`${this.$config.server_url}/web/2.0/extradata/${this.$route.params.token}`, { ed_data });

			this.isLoading = false;

			if(response.data.err) {

			} else {
        this.buildingType = "";
        this.internetProvider = "";
        this.connectionType = "";
        this.tvChannelsProvider = "";
        this.tvBrand = "";
        this.seniorDistance = "";
        this.relativeDistance = "";
        this.isAnswered = true;
			}
    }
  },
};
</script>

<style lang="scss" scoped>
  .question-label {
    font-weight: 500;
  }

  .question-hint {
    color: #a0a0a0;
  }
</style>